<!-- src/components/LeadsPanel.svelte -->
<script>
  import { agentStore } from '$lib/stores'

  export let leads = []
  export let groupFilter = null

  $: filteredLeads = groupFilter 
    ? leads.filter(l => l.group_id === groupFilter)
    : leads

  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleString()
  }
</script>

<div class="leads-panel glass-panel">
  <div class="panel-header">
    <h3 class="panel-title">Lead Management</h3>
    <div class="header-actions">
      <select class="filter-select" bind:value={groupFilter}>
        <option value={null}>All Groups</option>
        {#each $agentStore.groups as group}
          <option value={group.id}>{group.icon} {group.name}</option>
        {/each}
      </select>
      <button class="btn-primary">+ Add Lead</button>
    </div>
  </div>

  {#if filteredLeads.length === 0}
    <div class="empty-state">
      <div class="empty-icon">◎</div>
      <p>No leads found</p>
      <span>Leads will appear here when discovered by agents</span>
    </div>
  {:else}
    <table class="leads-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Company</th>
          <th>Source</th>
          <th>Status</th>
          <th>Group</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {#each filteredLeads as lead}
          <tr>
            <td><strong>{lead.name}</strong></td>
            <td>{lead.company || '—'}</td>
            <td>{lead.source}</td>
            <td>
              <span class="status-badge status-{lead.status}">{lead.status}</span>
            </td>
            <td>{lead.group_id}</td>
            <td>{formatDate(lead.created_at)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</div>

<style>
  .leads-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .panel-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .filter-select {
    padding: 8px 12px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    font-size: 13px;
    cursor: pointer;
  }

  .btn-primary {
    padding: 8px 16px;
    background: var(--accent-primary);
    color: white;
    border: none;
    border-radius: var(--radius-sm);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px;
    gap: 8px;
  }

  .empty-icon {
    font-size: 48px;
    opacity: 0.5;
  }

  .empty-state p {
    color: var(--text-secondary);
  }

  .empty-state span {
    color: var(--text-muted);
    font-size: 13px;
  }

  .leads-table {
    width: 100%;
    border-collapse: collapse;
  }

  .leads-table th {
    text-align: left;
    padding: 10px 12px;
    font-size: 11px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--glass-border);
  }

  .leads-table td {
    padding: 10px 12px;
    font-size: 13px;
    color: var(--text-secondary);
    border-bottom: 1px solid var(--glass-border);
  }

  .leads-table tr:hover td {
    background: var(--glass-bg);
  }

  .status-badge {
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 10px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .status-new { background: rgba(124, 92, 255, 0.15); color: var(--accent-primary); }
  .status-contacted { background: rgba(96, 165, 250, 0.15); color: #60a5fa; }
  .status-qualified { background: rgba(251, 191, 36, 0.15); color: #fbbf24; }
  .status-converted { background: rgba(74, 222, 128, 0.15); color: #4ade80; }
  .status-rejected { background: rgba(239, 68, 68, 0.15); color: #ef4444; }
</style>